export const PRODUCT_TRACKER_GROUP_CREATED = 'Product Tracker - Created a group'
export const PRODUCT_TRACKER_VIEW_PRODUCT_CHART =
  'Product Tracker - Page revisit and view product chart'
export const PRODUCT_TRACKER_VIEW_PRODUCT_ON_AMAZON =
  'Product Tracker - Page revisit and view product on Amazon'
export const PRODUCT_TRACKER_TRACK_PRODUCT =
  'Product Tracker - Started tracking a product'
